"use strict";

var _interopRequireWildcard = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _core = require("echarts/core");
var _renderers = require("echarts/renderers");
var _charts = require("echarts/charts");
var _components = require("echarts/components");
var _vueEcharts = _interopRequireWildcard(require("vue-echarts"));
var _leads = require("@/api/leads");
var _utils = require("@/utils");
(0, _core.use)([_renderers.CanvasRenderer, _charts.PieChart, _components.TitleComponent, _components.TooltipComponent, _components.LegendComponent]);
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.startDate = '';
    this.endDate = '';
    this.option = {
      title: {
        text: 'Inquiry By Source',
        left: 10,
        top: 10,
        textStyle: {
          color: '#121212',
          fontSize: 16,
          fontWeight: 'normal',
          fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif'
        }
      },
      tooltip: {
        trigger: 'item'
      },
      legend: {
        top: '18%',
        left: 'right',
        itemGap: 2,
        itemWidth: 15,
        itemHeight: 10
      },
      textStyle: {
        fontSize: 10,
        fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif'
      },
      series: [{
        name: 'Inquiry By Source',
        bottom: 20,
        width: '100%',
        type: 'pie',
        radius: '60%',
        center: ['50%', '65%'],
        labelLine: {
          show: false
        },
        label: {
          show: false
        },
        // adjust the start and end angle
        startAngle: 0,
        endAngle: 360,
        data: []
      }]
    };
  }
  created() {
    if (this.dateRange && this.dateRange.start && this.dateRange.end) {
      this.startDate = this.dateRange.start;
      this.endDate = this.dateRange.end;
    }
    this.fetchData();
  }
  async fetchData() {
    try {
      this.option.series[0].data = await (0, _leads.getLeadsBySourceCount)((0, _utils.getQuery)({
        startDate: this.startDate,
        endDate: this.endDate
      }));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: ''
})], default_1.prototype, "dateRange", void 0);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'SampleStatsRadialBarChart',
  components: {
    VChart: _vueEcharts.default
  },
  provide() {
    return {
      [_vueEcharts.THEME_KEY]: 'light'
    };
  }
})], default_1);
var _default = exports.default = default_1; // export default defineComponent({
//   name: 'SourcePieChart',
//   components: {
//     VChart
//   },
//   provide: {
//     [THEME_KEY]: 'light'
//   },
//   props: {
//     dateRange: {
//       type: String,
//       required: true,
//       default: ''
//     }
//   },
//   setup() {
//     const option = ref({
//       title: {
//         text: 'Lead By Source',
//         left: 10,
//         top: 10,
//         textStyle: {
//           color: '#121212',
//           fontSize: 16,
//           fontWeight: 'normal',
//           fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif'
//         }
//       },
//       tooltip: {
//         trigger: 'item'
//       },
//       legend: {
//         top: '18%',
//         left: 'right',
//         itemGap: 2,
//         itemWidth: 15,
//         itemHeight: 10
//       },
//       textStyle: {
//         fontSize: 10,
//         fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif'
//       },
//       series: [
//         {
//           name: 'Lead By Source',
//           bottom: 20,
//           width: '100%',
//           type: 'pie',
//           radius: ['50%', '80%'],
//           center: ['50%', '90%'],
//           // adjust the start and end angle
//           startAngle: 180,
//           endAngle: 360,
//           data: [
//             { value: 1048, name: 'Search Engine' },
//             { value: 735, name: 'Direct' },
//             { value: 580, name: 'Email' },
//             { value: 484, name: 'Union Ads' },
//             { value: 300, name: 'Video Ads' }
//           ]
//         }
//       ]
//     })
//     return { option }
//   },
//   created() {
//     if (this.dateRange && this.dateRange.start && this.dateRange.end) {
//       this.startDate = this.dateRange.start
//       this.endDate = this.dateRange.end
//     } else if (!this.dateRange) {
//       const date = new Date()
//       this.endDate = date.toISOString()
//       date.setMonth(date.getMonth() - 2)
//       this.startDate = date.toISOString()
//     }
//     this.fetchData()
//   },
//   methods: {
//     async fetchData() {
//       try {
//         this.option.series[0].data = await getLeadsBySourceCount(getQuery({ startDate: this.startDate, endDate: this.endDate }))
//       } catch (error) {
//         this.$notify({
//           title: 'Error',
//           type: 'error',
//           message: error.toString()
//         })
//       }
//     }
//   }
// })